@if (!isAdminRoute()) {
<heritage-header></heritage-header>
}
<router-outlet></router-outlet>
@if (!isAdminRoute()) {
<heritage-footer></heritage-footer>
}
<app-loading-spinner></app-loading-spinner>